export default "__VITE_ASSET__Ben3ANeu__"